import { makeApi } from "@zodios/core";
import { z } from "zod";

import {
  contentLanguageCreateSchema,
  contentLanguageSchema,
  contentLanguageUpdateSchema,
} from "@skilitics/nautilus-core-designer-data/schemas";

import { validationErrorSchema } from "../shared.ts";

export const contentLanguagesApi = makeApi([
  {
    method: "get",
    path: "/node-designs/:hostId/languages",
    alias: "getContentLanguages",
    parameters: [
      {
        type: "Path",
        name: "hostId",
        schema: z.string(),
      },
    ],
    response: z.array(contentLanguageSchema),
    errors: [
      {
        status: 404,
        schema: z.string(),
      },
    ],
  },
  {
    method: "post",
    path: "/node-designs/:hostId/languages",
    alias: "createContentLanguage",
    parameters: [
      {
        type: "Path",
        name: "hostId",
        schema: z.string(),
      },
      {
        type: "Body",
        name: "Language",
        schema: contentLanguageCreateSchema,
      },
    ],
    response: contentLanguageSchema,
    status: 201,
    errors: [
      {
        status: 404,
        schema: z.string(),
      },
      {
        status: 400,
        schema: validationErrorSchema,
      },
    ],
  },
  {
    method: "patch",
    path: "/node-designs/:hostId/languages/:lang",
    alias: "updateContentLanguage",
    parameters: [
      {
        type: "Path",
        name: "hostId",
        schema: z.string(),
      },
      {
        type: "Path",
        name: "lang",
        schema: z.string(),
      },
      {
        type: "Body",
        name: "Payload",
        schema: contentLanguageUpdateSchema,
      },
    ],
    response: z.void(),
    status: 204,
    errors: [
      {
        status: 404,
        schema: z.string(),
      },
    ],
  },
  {
    method: "delete",
    path: "/node-designs/:hostId/languages/:lang",
    alias: "deleteContentLanguage",
    parameters: [
      {
        type: "Path",
        name: "hostId",
        schema: z.string(),
      },
      {
        type: "Path",
        name: "lang",
        schema: z.string(),
      },
    ],
    response: z.void(),
    status: 204,
    errors: [
      {
        status: 404,
        schema: z.string(),
      },
    ],
  },
]);

export type ContentLanguage = z.infer<typeof contentLanguageSchema>;
